"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _month_area = _interopRequireDefault(require("./component/month_area"));

var _info = _interopRequireDefault(require("./info"));

var _keyday_props = require("./keyday_props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var splitDateDataByFormat = _spauiUtils.date.splitDateDataByFormat,
    joinDateDataToFormat = _spauiUtils.date.joinDateDataToFormat;
/**
 * @class
 */

var KeyDay =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(KeyDay, _PureComponent);

  function KeyDay(props) {
    var _this;

    _classCallCheck(this, KeyDay);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KeyDay).call(this, props));
    _this.state = {
      valueMap: _this.getValueMap({
        value: props.value,
        format: props.format
      }),
      keyDayMap: _this.getValueMap({
        value: props.keyday,
        format: props.format
      })
    }; // 默认日期

    _this.defaultDate = new Date();
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(KeyDay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        valueMap: this.getValueMap({
          value: nextProps.value,
          format: nextProps.format
        }),
        keyDayMap: this.getValueMap({
          value: nextProps.keyday,
          format: nextProps.format
        })
      });
    } // 获取对应的key

  }, {
    key: "getKey",
    value: function getKey() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return "".concat(data.year, "_").concat(data.month);
    }
  }, {
    key: "getValueMap",
    value: function getValueMap() {
      var _this2 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props$value = props.value,
          value = _props$value === void 0 ? [] : _props$value,
          format = props.format; // 是否在数组中

      var inArray = function inArray() {
        var arrData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var item = arguments.length > 1 ? arguments[1] : undefined;
        var index = -1;

        if (typeof item === 'string') {
          index = (0, _spauiUtils.indexOf)(arrData, item);
        } else if ((0, _spauiUtils.isArray)(item)) {
          arrData.map(function (arrItem, itemIndex) {
            var equal = true;

            if ((0, _spauiUtils.isArray)(arrItem) && arrItem.length === item.length && item.length > 0 && index < 0) {
              arrItem.map(function (arrSubItem, arrSubIndex) {
                if (arrSubItem !== item[arrSubIndex]) {
                  equal = false;
                }

                return arrSubItem;
              });

              if (equal) {
                index = itemIndex;
              }
            }

            return arrItem;
          });
        }

        return index;
      }; // 如果是数组，但是元素不满足就转成单个日期


      var transformData = function transformData(item) {
        var result = item;

        if ((0, _spauiUtils.isArray)(item)) {
          if (item.length <= 1) {
            result = item[0] || '';
          } else if (item.length === 2) {
            if (!item[0]) {
              result = item[1] || '';
            } else if (!item[1]) {
              result = item[0] || '';
            }
          }
        }

        return result;
      };

      var result = {};
      var startData = {};
      var endData = {};
      var startYear = 0;
      var startMonth = 0;
      var endYear = 0;
      var endMonth = 0;
      var forStartYear = 0;
      var forStartMonth = 0;
      var forEndMonth = 0;
      var forStartDate = 0;
      var forEndDate = 0;
      var data = {};
      var key = '';
      var theMonthStartDate = '';
      var theMonthEndDate = '';
      var theMonthTheDate = null;
      value.map(function (curItem) {
        var item = transformData(curItem);
        var itemValue = null;

        if ((0, _spauiUtils.isArray)(item) && item.length === 2 && item[0] && item[1]) {
          startData = splitDateDataByFormat(item[0], format);
          endData = splitDateDataByFormat(item[1], format);
          startYear = startData.year;
          startMonth = startData.month;
          endYear = endData.year;
          endMonth = endData.month;
          forStartYear = startYear;

          for (; forStartYear <= endYear; forStartYear++) {
            if (forStartYear === startYear) {
              forStartMonth = startMonth;
            } else {
              forStartMonth = 0;
            }

            if (forStartYear === endYear) {
              forEndMonth = endMonth;
            } else {
              forEndMonth = 11;
            }

            for (; forStartMonth <= forEndMonth; forStartMonth++) {
              if (forStartYear === startYear && forStartMonth === startMonth) {
                forStartDate = startData.date;
              } else {
                forStartDate = 1;
              }

              if (forStartYear === endYear && forStartMonth === endMonth) {
                forEndDate = endData.date;
              } else {
                theMonthTheDate = new Date(forStartYear, forStartMonth + 1, 0);
                forEndDate = theMonthTheDate.getDate();
              }

              key = _this2.getKey({
                year: forStartYear,
                month: forStartMonth
              });
              theMonthStartDate = joinDateDataToFormat({
                year: forStartYear,
                month: forStartMonth,
                date: forStartDate
              }, format);
              theMonthEndDate = joinDateDataToFormat({
                year: forStartYear,
                month: forStartMonth,
                date: forEndDate
              }, format);

              if (new Date(theMonthStartDate).getTime() > new Date(theMonthEndDate).getTime()) {
                itemValue = [theMonthEndDate, theMonthStartDate];
              } else {
                itemValue = [theMonthStartDate, theMonthEndDate];
              }

              if (!result[key]) {
                result[key] = [itemValue];
              } else if (inArray(result[key], itemValue) < 0) {
                result[key].push(itemValue);
              }
            }
          }
        } else if (typeof item === 'string' && item) {
          data = splitDateDataByFormat(item, format);
          key = _this2.getKey(data);
          itemValue = item;

          if (!result[key]) {
            result[key] = [itemValue];
          } else if (inArray(result[key], itemValue) < 0) {
            result[key].push(itemValue);
          }
        }

        return item;
      });
      return result;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var valueMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var result = [];
      var valueMapData = [];
      var valueData = [];
      var key = '';
      var lastDate = '';

      var getNextDate = function getNextDate(curValueData, initLastDate, index) {
        var len = curValueData.length || 0;
        var data = '';
        var i = index;
        var nextIndex = index;
        var theLastDate = initLastDate;
        var nextDate = initLastDate;
        var firstDate = '';
        var secondDate = '';

        if (theLastDate) {
          i = i + 1;

          for (; i < len; i++) {
            data = curValueData[i] || '';

            if (data) {
              if ((0, _spauiUtils.isArray)(data)) {
                firstDate = data[0] || '';
                secondDate = data[1] || '';
              } else {
                firstDate = data;
                secondDate = data;
              }

              if (new Date(firstDate).getTime() - new Date(theLastDate).getTime() <= 86400000) {
                theLastDate = secondDate;
                nextDate = secondDate;
                nextIndex = i;
              }
            }
          }
        }

        return {
          nextDate: nextDate,
          nextIndex: nextIndex
        };
      };

      for (key in valueMap) {
        if (valueMap[key] && valueMap[key].length > 0) {
          valueMapData = valueMapData.concat((0, _spauiUtils.cloneArray)(valueMap[key]));
        }
      } // 排序


      valueMapData.map(function (item) {
        var firstDate = '';
        var curIndex = -1;

        if ((0, _spauiUtils.isArray)(item)) {
          firstDate = item[0];
        } else {
          firstDate = item;
        }

        if (valueData.length < 1) {
          valueData.push(item);
        } else {
          valueData.map(function (valueItem, index) {
            var theDate = '';

            if ((0, _spauiUtils.isArray)(valueItem)) {
              theDate = valueItem[0];
            } else {
              theDate = valueItem;
            }

            if (new Date(theDate).getTime() < new Date(firstDate).getTime()) {
              curIndex = index;
            }

            return valueItem;
          });

          if (curIndex < 0) {
            valueData.unshift(item);
          } else if (curIndex === valueData.length - 1) {
            valueData.push(item);
          } else {
            curIndex = curIndex + 1;
            valueData = valueData.slice(0, curIndex).concat([item]).concat(valueData.slice(curIndex));
          }
        }

        return item;
      });
      valueData.map(function (curItem, index) {
        var nextData = {};
        var nextDate = '';
        var nextIndex = -1;
        var item = curItem;
        var i = index;

        if (index < valueData.length - 1) {
          if ((0, _spauiUtils.isArray)(item)) {
            lastDate = item[1] || '';
          } else {
            lastDate = item;
          }

          if (lastDate) {
            nextData = getNextDate(valueData, lastDate, index);
            nextDate = nextData.nextDate;
            nextIndex = nextData.nextIndex;

            if (lastDate !== nextDate) {
              if ((0, _spauiUtils.isArray)(item)) {
                item[1] = nextDate;
              } else {
                item = [item, nextDate];
              }

              i = i + 1;

              for (; i <= nextIndex; i++) {
                valueData[i] = '';
              }
            }
          }
        }

        if (item) {
          result.push(item);
        }

        return curItem;
      });
      return result;
    }
  }, {
    key: "handleChange",
    value: function handleChange(year, month) {
      var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var keyday = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var onChange = this.props.onChange;
      var _this$state = this.state,
          _this$state$valueMap = _this$state.valueMap,
          valueMap = _this$state$valueMap === void 0 ? {} : _this$state$valueMap,
          _this$state$keyDayMap = _this$state.keyDayMap,
          keyDayMap = _this$state$keyDayMap === void 0 ? {} : _this$state$keyDayMap;
      var newValueMap = {};
      var newKeyDayMap = {};
      var key = '';
      var newValue = [];
      var newKeyDay = [];

      for (key in valueMap) {
        if (valueMap[key]) {
          newValueMap[key] = (0, _spauiUtils.cloneArray)(valueMap[key]);
        }
      }

      for (key in keyDayMap) {
        if (keyDayMap[key]) {
          newKeyDayMap[key] = (0, _spauiUtils.cloneArray)(keyDayMap[key]);
        }
      }

      key = this.getKey({
        year: year,
        month: month
      });
      newValueMap[key] = value;
      newKeyDayMap[key] = keyday;
      newValue = this.getValue(newValueMap);
      newKeyDay = this.getValue(newKeyDayMap);

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(newValue, newKeyDay);
      }
    } // 获取可选时间

  }, {
    key: "getOptionalTime",
    value: function getOptionalTime() {
      var _this$props = this.props,
          optionalStartRelativeDays = _this$props.optionalStartRelativeDays,
          optionalEndRelativeDays = _this$props.optionalEndRelativeDays,
          optionalStartDate = _this$props.optionalStartDate,
          optionalEndDate = _this$props.optionalEndDate;
      var defaultDate = this.defaultDate;
      var startDate = null;
      var endDate = null;
      var optionalStartDateData = {};
      var optionalEndDateData = {}; // 获得可选开始日期
      // 绝对时间

      if (!(0, _spauiUtils.isUndefined)(optionalStartDate)) {
        startDate = new Date(optionalStartDate); // 相对时间
      } else if (!(0, _spauiUtils.isUndefined)(optionalStartRelativeDays)) {
        var optionalStartRelativeDaysInt = parseInt(optionalStartRelativeDays, 10) || 0;
        startDate = new Date(defaultDate.getTime() + optionalStartRelativeDaysInt * 24 * 60 * 60 * 1000);
      }

      if (startDate) {
        optionalStartDateData = {
          year: startDate.getFullYear(),
          month: startDate.getMonth(),
          date: startDate.getDate()
        };
      } // 获得可选结束日期
      // 绝对时间


      if (!(0, _spauiUtils.isUndefined)(optionalEndDate)) {
        endDate = new Date(optionalEndDate); // 相对时间
      } else if (!(0, _spauiUtils.isUndefined)(optionalEndRelativeDays)) {
        endDate = new Date(defaultDate.getTime() + (parseInt(optionalEndRelativeDays, 10) || 0) * 24 * 60 * 60 * 1000);
      }

      if (endDate) {
        optionalEndDateData = {
          year: endDate.getFullYear(),
          month: endDate.getMonth(),
          date: endDate.getDate()
        };
      }

      return {
        optionalStartDateData: optionalStartDateData,
        optionalEndDateData: optionalEndDateData
      };
    } // 生成对应的月份

  }, {
    key: "genMonthList",
    value: function genMonthList() {
      var _this3 = this;

      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          format = _this$props2.format,
          type = _this$props2.type;
      var _this$state2 = this.state,
          _this$state2$valueMap = _this$state2.valueMap,
          valueMap = _this$state2$valueMap === void 0 ? {} : _this$state2$valueMap,
          keyDayMap = _this$state2.keyDayMap;

      var _this$getOptionalTime = this.getOptionalTime(),
          optionalStartDateData = _this$getOptionalTime.optionalStartDateData,
          optionalEndDateData = _this$getOptionalTime.optionalEndDateData;

      var startYear = optionalStartDateData.year,
          startMonth = optionalStartDateData.month;
      var endYear = optionalEndDateData.year,
          endMonth = optionalEndDateData.month; // 生成当前这一年的月份面板

      var genOneYearMonthArea = function genOneYearMonthArea(year) {
        var curStartMonth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var curEndMonth = arguments.length > 2 ? arguments[2] : undefined;
        var result = [];
        var len = curEndMonth;
        var i = curStartMonth;
        var key = '';

        for (; i <= len; i++) {
          key = _this3.getKey({
            year: year,
            month: i
          });
          result.push(_react["default"].createElement(_month_area["default"], {
            type: type,
            onChange: _this3.handleChange,
            key: key,
            value: valueMap[key] || [],
            keyday: keyDayMap[key] || [],
            year: year,
            month: i,
            disabled: disabled,
            optionalStartDateData: optionalStartDateData,
            optionalEndDateData: optionalEndDateData,
            format: format
          }));
        }

        return result;
      };

      var contents = [];
      var yearIndex = 1;

      if (startYear === endYear) {
        // 当前这一年
        contents = genOneYearMonthArea(startYear, startMonth, endMonth);
      } else if (startYear < endYear) {
        // 开始日期那一年
        contents = genOneYearMonthArea(startYear, startMonth, 11);

        if (endYear - startYear > 1) {
          for (; yearIndex < endYear; yearIndex++) {
            contents = contents.concat(genOneYearMonthArea(startYear + yearIndex, 0, 11));
          }
        } // 结束日期那一年


        contents = contents.concat(genOneYearMonthArea(endYear, 0, endMonth));
      }

      return contents;
    }
  }, {
    key: "render",
    value: function render() {
      var type = this.props.type;
      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-keyday', {
          'with-keyday-on': type === 'keyday'
        })
      }, KeyDay), _react["default"].createElement("div", {
        className: "spaui-keyday-inner"
      }, this.genMonthList()));
    }
  }]);

  return KeyDay;
}(_react.PureComponent); // 组件标记


_defineProperty(KeyDay, "propTypes", _keyday_props.propTypes);

_defineProperty(KeyDay, "defaultProps", _keyday_props.defaultProps);

(0, _spauiUtils.setComponentMark)(KeyDay, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = KeyDay;
exports["default"] = _default;